<div class="reports-dialog">
  <div class="dialog-title-container">
    <div id="reports-dialog-title" class="dialog-title-text">{{ data.options.primaryTabName | translate }}</div>
  </div>
  <div class="tab-container app-dark-bg">            
          <div class="tabs">
              <a id="reports-tab-all" [class.active]="getViewMode() == ViewReportMode.All" (click)="changeViewMode(ViewReportMode.All)">{{ "lbl_all_reports" | translate}}</a>
              @if (isAiReportsEnabled) {
                <a id="reports-tab-ai" [class.active]="getViewMode() == ViewReportMode.Ai" (click)="changeViewMode(ViewReportMode.Ai)">{{"lbl_ai_reports" | translate}}</a>
              }
              <a id="reports-tab-published" [class.active]="getViewMode() == ViewReportMode.Published" (click)="changeViewMode(ViewReportMode.Published)">{{"lbl_published_reports" | translate}}</a>
          </div>
          <div class="tab-forms app-light-bg">
      @if (getViewMode() === ViewReportMode.All) {
        <app-all-reports [data]="data"></app-all-reports>
      }

      @if (isAiReportsEnabled && getViewMode() === ViewReportMode.Ai) {
        <app-ai-reports [data]="data"></app-ai-reports>
      }

      @if (getViewMode() === ViewReportMode.Published) {
        <app-report-manager-main></app-report-manager-main>
      }

  </div>
</div>
